import React, { useContext, useState, useEffect } from "react";

import {
  Stack,
  Grid2 as Grid,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";

//   icon
import { BiMinusCircle } from "react-icons/bi";

//Srcs
import "../../Style/dialogStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { 
  SelectAcademicYear,
  SelectSchool, 
  SelectLevel,
  SelectGroup
} from "../../Function/DynamicSelect";
import { DELETE_MANY_STUDENTS } from "../../Schema/Student";


export default function DeleteStudentData({
  open,
  handleClose,
  setRefetch,
}) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  const [academicYearVal, setAcademicYearVal] = useState({ id: null, title: "", });
  const [schoolVal, setSchoolVal] = useState({ id: "", title: "" });
  const [levelVal, setLevelVal] = useState({ id: "", title: "" })
  const [groupVal, setGroupVal] = useState({ id: "", title: "" });



  //======================== Create User =========================
  const [deleteManyStudent] = useMutation(DELETE_MANY_STUDENTS, {
    onCompleted: ({ deleteManyStudent }) => {
      // console.log("deleteManyStudent", deleteManyStudent);
      setLoading(false);
      if (deleteManyStudent?.is_success === true) {
        setAlert(true, "success", deleteManyStudent?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", deleteManyStudent?.message);
        // console.log("error:::", deleteManyStudent?.message);
        handleClose();
      }
    },
    onError: (error) => {
      setLoading(false);
      if (error?.message?.message_kh && error?.message?.message_en) {
        setAlert(true, "error", error?.message);
      } else {
        setAlert(true, "error", {
          message_kh: error?.message,
          message_en: error?.message,
        });
      }
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    academicYearId: Yup.string().required(t("require")),
    schoolId: Yup.string().required(t("require")),
    levelId: Yup.string().required(t("require")),
  });

  const formik = useFormik({
    initialValues: {
      academicYearId: "",
      schoolId: "",
      levelId: "",
      groupId: ""
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
    
      // setLoading(true);
      deleteManyStudent({
        variables: {
          academicYearId: academicYearVal?.id,
          schoolId: schoolVal?.id,
          levelId: levelVal?.id,
          groupId: groupVal?.id
        },
      });
    },
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  console.log("errors", errors)

  useEffect(() => {
    setFieldValue("academicYearId", academicYearVal?.id);
    setFieldValue("schoolId", schoolVal?.id);
    setFieldValue("levelId", levelVal?.id);
    setFieldValue("groupId", groupVal?.id);
  },[academicYearVal?.id, schoolVal?.id, levelVal?.id, groupVal?.id])

  useEffect(() => {
    resetForm();
    setAcademicYearVal({ id: "", title: "" });
    setSchoolVal({ id: "", title: "" });
    setLevelVal({ id: "", title: "" });
    setGroupVal({ id: "", title: "" });
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography
              className={language === "en" ? "dialog-title" : "dialog-title-kh"}
            >
              {t("delete_stu")}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Stack direction="column" justifyContent="center" spacing={2}>
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 6 }}>
                  <Typography
                    className={
                      language === "kh" ? "header-text-kh" : "header-text"
                    }
                  >
                    {t(`academic_year`)}
                  </Typography>
                  <SelectAcademicYear
                    selectedVal={academicYearVal}
                    setSelectedVal={setAcademicYearVal}

                  />
                  {!!errors.academicYearId && touched.academicYearId && (
                    <FormHelperText error id="outlined-adornment-password">
                      {errors.academicYearId}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid size={{ xs: 6 }}>
                  <Typography
                    className={
                      language === "en" ? "field-title" : "field-title-kh"
                    }
                  >
                    {t("school")}
                  </Typography>
                  <SelectSchool
                    selectedVal={schoolVal}
                    setSelectedVal={setSchoolVal}
                  />
                  {!!errors.schoolId && touched.schoolId && (
                    <FormHelperText error id="outlined-adornment-password">
                      {errors.schoolId}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid size={{ xs: 6 }}>
                  <Typography
                    className={language === "kh" ? "header-text-kh" : "header-text"}
                  >
                    {t(`grade_level`)}
                  </Typography>
                  <SelectLevel
                    selectedVal={levelVal}
                    setSelectedVal={setLevelVal}
                  />
                  {!!errors.levelId && touched.levelId && (
                    <FormHelperText error id="outlined-adornment-password">
                      {errors.levelId}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid size={{ xs: 6}}>
                  <Typography
                    className={language === "kh" ? "header-text-kh" : "header-text"}
                  >
                    {t(`group`)}
                  </Typography>
                  <SelectGroup
                    selectedVal={groupVal}
                    setSelectedVal={setGroupVal}
                  />
                  {!!errors.groupId && touched.groupId && (
                    <FormHelperText error id="outlined-adornment-password">
                      {errors.groupId}
                    </FormHelperText>
                  )}
                </Grid>
              </Grid>
            </Form>
            <Typography className={language === "en" ? "text" : "text-kh"} sx={{color: "red"}}>
              {/* Note: multiple students and their attendance data across the chosen schools and levels will be deleted.  */}
              {t("note_of_delete_multiple_student")}
            </Typography>
            <Typography className={language === "en" ? "text" : "text-kh"}>
              {t("do_you_want_to_delete_this_data")}
            </Typography>

          </Stack>
        </FormikProvider>
      </DialogContent>
      <DialogActions>
        <Grid size={{ xs: 12 }} className="create-container">
          {loading ? (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
            >
              {t("loading")}
            </Button>
          ) : (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
              onClick={handleSubmit}
            // disabled={csvData.length >= 1 ? true : false}
            >
              {t("btn-create")}
            </Button>
          )}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
